import PointInfoExcel from './PointInfoExcel';

export default PointInfoExcel;
